import { CircularProgress } from '@mui/material';


const LoadingLogo = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '90%',
                height: '90%',
            }}
        >
            <CircularProgress style={{ color: '#94cfec' }} size={30} />
        </div>
    )
};

export default LoadingLogo;
